import React, { useRef, useEffect, useState } from "react";
import { shallowEqual, useSelector, connect, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "./authRedux";
import * as apiUtenti from "../../../api/users";

// AG: Aggiunto per ottenere il token FCM
import { 
  requestForToken, 
  checkNotificationPermission, 
  requestNotificationPermission 
} from "../../Firebase/firebase";

function AuthInit(props) {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const { authToken } = useSelector(
    ({ auth }) => ({
      authToken: auth.authToken,
    }),
    shallowEqual
  );
  
  // We should request user by authToken before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          if (authToken !== "") {
            const user = await apiUtenti.getUserByToken(authToken);
            
            // ✅ Controlla lo stato dei permessi
            const permissionStatus = checkNotificationPermission();
            
            // Se i permessi sono già concessi, ottieni il token automaticamente
            if (permissionStatus === 'granted') {
              console.log('Permessi già concessi, verifico il token FCM');
              // Se l'utente non ha un token salvato, forza il refresh per sicurezza
              const shouldRefresh = !user.fcmToken;
              // Rendi l'ottenimento del token FCM non bloccante
              requestForToken(authToken, shouldRefresh).then((token) => {
                if (token && (!user.fcmToken || user.fcmToken !== token)) {
                  const updatedUser = { ...user, fcmToken: token };
                  dispatch(auth.actions.setUser(updatedUser));
                }
              }).catch((error) => {
                console.warn('Errore nellottenimento del token FCM, ma lapp continua a funzionare:', error);
              });
            } else {
              console.log('Permessi non concessi. Stato:', permissionStatus);
              // Non fare nulla qui - l'utente dovrà cliccare un pulsante per attivare le notifiche
            }

            dispatch(auth.actions.fulfillUser(user));
          } else {
            console.log("login attemped by authinit");
          }
        }
      } catch (error) {
        if (!didRequest.current) {
          dispatch(auth.actions.logout());
        }
        if (error.code === 403) {
          dispatch(auth.actions.logout());
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (authToken) {
      requestUser(authToken);
    } else {
      dispatch(auth.actions.fulfillUser(undefined));
      setShowSplashScreen(false);
    }
    //eslint-disable-next-line
  }, []);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
}

export default connect(null, auth.actions)(AuthInit);